export const successTemp = `
  <div class="registration-section registration-section-sucess">
  <div class="section-top">
    <span>라슬란 선발대에 신청 <br data-rwd-display='mobile'>완료되었습니다.</span>
  </div>
  <div class="section-body">
      <hr>
      <div class="section-area section-area-sucess">
          <p class="area-title"> </p>
          <div class="area-content area-content-sucess">
              <div class="area-content-top">
                  지원해 주셔서 감사합니다.<br>
                  THRONE AND LIBERTY에 많은 관심과 성원 부탁드립니다.<br>
                  <br>
                  <span class="strong"></span>
                  선정 결과는 5월 18일에 발표 됩니다.
              </div>
          </div>
      </div>

  </div>
  </div>
  <div class="btn-go-brand">
  <a href="/"></a>
  </div>
`;
